import React, {useState} from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from 'react-bootstrap';
import Swal from "sweetalert2";



function ModalConfirmarHorario({reserva, quienEs}){

    // variables modal
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const horaReserva = reserva?.horaConfirmada && reserva?.horaConfirmada !== "NA"
        ? reserva.horaConfirmada
        : reserva?.horaSolicitada && reserva?.horaSolicitada !== "NA"
            ? reserva.horaSolicitada
            : "Horario no definido";

    const franjaReserva = reserva?.franja && reserva?.franja !== "NA"
        ? reserva.franja
        : "Sin franja";

    const textoFranja = {
        manana: "Mañana",
        tarde: "Tarde",
        noche: "Noche",
    }[franjaReserva] || franjaReserva;

    const contraparte = quienEs === "Vendedor" ? "comprador" : "vendedor";
    const contraparteTitulo = quienEs === "Vendedor" ? "Comprador" : "Vendedor";

    
    async function confirmacionHorario(){
        try{
            const resConfir = await axios.post("/confirmar-horario", {
                params: { idReserva: reserva?._id }
            });

            if (!resConfir?.data?.exito) {
                await Swal.fire({
                    icon: "error",
                    title: "No fue posible confirmar",
                    text: resConfir?.data?.mensaje || "Intenta nuevamente.",
                    customClass: {
                        popup: 'mi-modal',
                        confirmButton: 'mi-boton-confirmar',
                        cancelButton: 'mi-boton-cancelar'
                    }
                });
                return;
            }

            await Swal.fire({
                icon: "success",
                title: "Horario confirmado",
                text: resConfir?.data?.mensaje || "La reserva fue confirmada correctamente.",
                customClass: {
                    popup: 'mi-modal',
                    confirmButton: 'mi-boton-confirmar',
                    cancelButton: 'mi-boton-cancelar'
                }
            });
            window.location.reload();
            return
        }
        catch(err){
            await Swal.fire({
                icon: "error",
                title: "Error al confirmar horario",
                text: err?.response?.data?.mensaje || "No fue posible confirmar el horario. Intenta nuevamente.",
                customClass: {
                    popup: 'mi-modal',
                    confirmButton: 'mi-boton-confirmar',
                    cancelButton: 'mi-boton-cancelar'
                }
            });
        }
    }
 

    return(
        <div>
        <Button className="w-100 mt-3 rounded-pill fw-semibold" variant="secondary" onClick={handleShow}>
            <i className="bi bi-calendar-check me-2"></i>
            Confirmar horario del {contraparte}
        </Button>

        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton className="border-0 pb-0">
                <Modal.Title className="fw-bold text-dark">
                    Confirmar horario
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div>
                    <div className="d-flex align-items-start gap-3 mb-3">
                        <div
                            className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                            style={{ width: 46, height: 46, background: "rgba(var(--azul-logo-claro-rgb),0.10)", color: "var(--azul-logo-claro)" }}
                        >
                            <i className="bi bi-calendar-check" style={{ fontSize: "1.35rem" }}></i>
                        </div>

                        <div>
                            <h3 className="h5 fw-bold text-dark mb-1">
                                ¿Confirmas este horario?
                            </h3>
                            <p className="text-muted mb-0" style={{ fontSize: "0.95rem", lineHeight: 1.45 }}>
                                El {contraparte} propuso este horario para la reserva. Al confirmarlo, quedará como horario fijo del servicio.
                            </p>
                        </div>
                    </div>

                    <div className="border rounded-4 p-3 mb-3 bg-light">
                        <p className="text-muted fw-semibold mb-3" style={{ fontSize: "0.88rem", letterSpacing: "0.02em", textTransform: "uppercase" }}>
                            Horario seleccionado
                        </p>

                        <div className="row g-3">
                            <div className="col-6">
                                <div className="bg-white border rounded-4 p-3 h-100">
                                    <span className="text-muted d-block mb-1" style={{ fontSize: "0.85rem" }}>Hora</span>
                                    <span className="fw-bold text-dark" style={{ fontSize: "1.15rem" }}>{horaReserva}</span>
                                </div>
                            </div>

                            <div className="col-6">
                                <div className="bg-white border rounded-4 p-3 h-100">
                                    <span className="text-muted d-block mb-1" style={{ fontSize: "0.85rem" }}>Franja</span>
                                    <span className="fw-bold text-dark" style={{ fontSize: "1.15rem" }}>{textoFranja}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="alert alert-warning rounded-4 border-0 mb-4" style={{ fontSize: "0.9rem", lineHeight: 1.45 }}>
                        <div className="fw-semibold mb-1">
                            <i className="bi bi-info-circle me-2"></i>
                            Antes de confirmar
                        </div>
                        Si este horario no te sirve, habla con el {contraparte} por el chat de la reserva para modificarlo. Solo tendrán <strong>2 intentos</strong>; si pasa una hora sin confirmación, quedará fijo el último horario propuesto.
                    </div>
                    
                    <button onClick={confirmacionHorario} className="btn btn-primary rounded-pill w-100 fw-semibold py-2">
                        <i className="bi bi-check2-circle me-2"></i>
                        Confirmar horario
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    </div>
    );

}



export default ModalConfirmarHorario;